import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const ComissaoFlexService = {
    deletarExcelParametros(fileRequest: any) {
        return BaseService.conectarEndpoint(fileRequest, 'flex/comissao/excel/deletar', 'excelComissaoFlexDeletar');
    },
    comissaoFlexExcelPost(fileRequest: any) {
        return BaseService.conectarEndpoint(fileRequest, 'flex/comissao/excel', 'excelComissaoFlex');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> {
        return Client.getBlob('flex/comissao/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> {
        return Client.post('flex/comissao/eventGrid', {});
    }
};

export default ComissaoFlexService;
